import React, { useState, useCallback } from "react";

// libs
import { Row, Spin, Tooltip, Icon, Col } from "antd";
import moment from "moment";

// Styles
import { Card } from "../../styles";

// Components
import useKpiContext from "../../../../hooks/useKpiContext";

//Services
import { formatNumberAbbreviated } from "../../../../utils/numberUtils";
//Icons
import AlertIcon from "../../icons/alert";
import ChartIcon from "../../icons/chart";
import InfoIcon from "../../../../components/utils/icons/info";

const KpiCostCattle = () => {
  const { kpiCostCattle: kpiData, updateKpiSelected } = useKpiContext();
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const [isTooltipErrorVisible, setIsTooltipErrorVisible] = useState(false);

  const handleShowTooltip = useCallback(() => {
    setIsTooltipVisible(true);
    setTimeout(() => {
      setIsTooltipVisible(false);
    }, 2000);
  }, []);

  const handleShowTooltipError = useCallback(() => {
    setIsTooltipErrorVisible(true);
    setTimeout(() => {
      setIsTooltipErrorVisible(false);
    }, 2000);
  }, []);

  return (
    <Card
      xs={23}
      sm={23}
      md={23}
      lg={7}
      xl={7}
      className={kpiData.isSelected ? " border-green" : ""}
      onClick={() =>
        !kpiData.isLoading ? updateKpiSelected("CUSTO_POR_REBANHO") : null
      }
    >
      <Spin spinning={kpiData.isLoading} size="small">
        <div className="header">
          <span>
            <Tooltip
              visible={isTooltipErrorVisible}
              title={`Último processamento: ${
                kpiData.data?.kpiDate != null
                  ? moment(kpiData.data.kpiDate).format("DD/MM/YYYY")
                  : "Sem data"
              }`}
            >
              {kpiData.data.error ? (
                <Icon
                  type="exclamation-circle"
                  className="iconError"
                  theme="filled"
                  onClick={() => handleShowTooltipError()}
                />
              ) : null}
            </Tooltip>
            CUSTO REBANHO
          </span>
          <span>
            {!kpiData?.data?.isComplete ? null : kpiData?.data?.goalAchieved ? (
              <ChartIcon />
            ) : (
              <AlertIcon />
            )}
          </span>
        </div>

        <div className="content">
          <Row style={{ width: "100%" }} type="flex" justify="space-between">
            <Col span={8}>
              <Tooltip
                visible={isTooltipVisible}
                placement="top"
                title="Custo Total (Aquisição + Adm/Operac. + Nutrição)."
              >
                <h3>Custo Total</h3>
                <span className="span-font">
                  <b>
                    {kpiData?.data?.kpiValue == null
                      ? "-"
                      : formatNumberAbbreviated(
                          kpiData.data?.parameters?.CostHistory || 0,
                        )}{" "}
                  </b>
                </span>
              </Tooltip>
            </Col>
            <Col span={8}>
              <Tooltip
                visible={isTooltipVisible}
                placement="bottom"
                title="Custo total / Qtde Animais."
              >
                <h3>Custo /cab.</h3>
                <span className="span-font">
                  <b>
                    {kpiData?.data?.kpiValue == null
                      ? "-"
                      : formatNumberAbbreviated(kpiData?.data?.kpiValue || 0)}
                  </b>
                </span>
              </Tooltip>
            </Col>
            <Col span={8}>
              <Tooltip
                visible={isTooltipVisible}
                placement="right"
                title="Total de @ x Valor @ de Mercado."
              >
                <h3>Valor Atual</h3>
                <span className="span-font">
                  <b>
                    {kpiData?.data?.kpiValue == null
                      ? "-"
                      : formatNumberAbbreviated(
                          kpiData.data?.parameters?.AssetValue || 0,
                        )}{" "}
                  </b>
                </span>
              </Tooltip>
            </Col>
          </Row>
          <Row type="flex">
            <InfoIcon onClick={() => handleShowTooltip()} />
          </Row>
        </div>
      </Spin>
      {!kpiData?.data?.isComplete ? <div className="banner-image" /> : null}
    </Card>
  );
};

export default KpiCostCattle;
